// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button.disabled {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modal-details/modal-details.component.scss"],"names":[],"mappings":"AAMA;EACC,YAAA;AALD","sourcesContent":[".modal-details-header {\r\n}\r\n.modal-details-content {\r\n// --ion-background-color: var(--ion-color-lighter-light);\r\n}\r\n\r\nion-button.disabled {\r\n\topacity: 0.3;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
